// Barcode comparison shared by order picking and stock take.
//
// Scanners and Priority disagree about the leading zero on retail barcodes: a 12-digit
// UPC-A is the same code as the 13-digit EAN-13 with a '0' prefix, and either side may
// hold either form. So a match is exact, or one side equals the other with a single
// leading zero added.
export const barcodesMatch = (scanned, stored) => {
  const a = String(scanned ?? '').trim();
  const b = String(stored ?? '').trim();
  if (!a || !b) return false;
  return a === b || a === '0' + b || b === '0' + a;
};
